export default __webpack_public_path__ + "static/media/img-0723-estonia-half-face.0d97c57f.png";